<template>
  <AddTeacher update />
</template>
<script>
import appConfig from '@/app.config'
import AddTeacher from '../../../components/mooc/teachers/AddTeacher.vue'
export default {
  page: {
    title: 'ویرایش اطلاعات استاد',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-edit-teachers',
  components: {
    AddTeacher,
  },
}
</script>
